/**
 * @generated SignedSource<<9ef6c003914af8778ec7755863df4606>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { Fragment, ReaderFragment } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type BestPaymentDrawer_PaymentOption$data = {
  readonly paymentMethod: {
    readonly name: string;
  };
  readonly " $fragmentSpreads": FragmentRefs<"PaymentMethodInfoContent_PaymentOption">;
  readonly " $fragmentType": "BestPaymentDrawer_PaymentOption";
};
export type BestPaymentDrawer_PaymentOption$key = {
  readonly " $data"?: BestPaymentDrawer_PaymentOption$data;
  readonly " $fragmentSpreads": FragmentRefs<"BestPaymentDrawer_PaymentOption">;
};

const node: ReaderFragment = {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "BestPaymentDrawer_PaymentOption",
  "selections": [
    {
      "alias": null,
      "args": null,
      "concreteType": "PaymentMethod",
      "kind": "LinkedField",
      "name": "paymentMethod",
      "plural": false,
      "selections": [
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "name",
          "storageKey": null
        }
      ],
      "storageKey": null
    },
    {
      "args": null,
      "kind": "FragmentSpread",
      "name": "PaymentMethodInfoContent_PaymentOption"
    }
  ],
  "type": "PaymentOption",
  "abstractKey": null
};

(node as any).hash = "5718621a3952c6d37ddd27f818402962";

export default node;
